module.exports = __webpack_public_path__ + "img/policia_estatal_down_selected.20f8a90e.svg";